import { Request } from '@mam/main/ApiClient';

export type SetReadResponse = Record<never, never>;

export enum SetReadError {}

export class SetReadRequest implements Request<SetReadResponse, SetReadResponse> {
	public readonly api = 'pigeon';
	public readonly body: BodyInit;
	public readonly knownErrorCodes = Object.values(SetReadError);
	public readonly method = 'put';
	public readonly path: string;

	public constructor(notificationIds: string[]) {
		this.body = JSON.stringify({
			notificationIds,
		});
		this.path = `notifications/read`;
	}
}
